// extracted by mini-css-extract-plugin
export default {"PageNotFound":"PageNotFound_PageNotFound__XhW7h","PageNotFoundWrapper":"PageNotFound_PageNotFoundWrapper__oDNWd","ErrorImage":"PageNotFound_ErrorImage__FXb59"};